import { UpsertIntegrationNotificationSettingsInput } from "shared/types/integrations";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const upsertIntegrationNotificationSettings = async (
  data: UpsertIntegrationNotificationSettingsInput
) => {
  try {
    const url = "/v1/integration/notification/settings";
    const response = await axiosClient.post(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getAllIntegrationNotificationSettings = async () => {
  try {
    const url = "/v1/integration/notification/settings";
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getIntegrationNotificationSettingsById = async (
  sourceId: string
) => {
  try {
    console.log("sourceId", sourceId);
    const url = `/v1/integration/notification/settings/${sourceId}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
